import {
  OFFICE_SEO_DEFAULT_CLIENT_ENGAGEMENT,
  OFFICE_SEO_SF_FURNITURE_FREIGHT_LOCAL,
  OFFICE_SEO_SF_INTERNET_RISER_LOCAL,
  OFFICE_SEO_SF_LOGISTICS_LOCAL,
  OFFICE_SEO_SF_OFFICE_ASSISTANT_COMPLIANCE_LOCAL,
  OFFICE_SEO_SF_PANTRY_DELIVERY_LOCAL,
  OFFICE_SEO_SF_DEEP_CLEANING_LOCAL,
  OFFICE_SEO_SF_CARPET_CLEANING_LOCAL,
  OFFICE_SEO_SF_WINDOW_CLEANING_LOCAL,
  OFFICE_SEO_SF_GLASS_CLEANING_LOCAL,
  OFFICE_SEO_SF_WASTE_RECYCLING_LOCAL,
  OFFICE_SEO_SF_PANTRY_INVENTORY_LOCAL,
  OFFICE_SEO_SF_COFFEE_SERVICE_LOCAL,
  OFFICE_SEO_SF_WATER_SERVICE_LOCAL,
  OFFICE_SEO_SF_TEAM_LUNCH_LOCAL,
  OFFICE_SEO_SF_BREAKFAST_CATERING_LOCAL,
  OFFICE_SEO_SF_INDIVIDUAL_MEALS_LOCAL,
  OFFICE_SEO_SF_AD_HOC_CATERING_LOCAL,
  OFFICE_SEO_SF_HAPPY_HOUR_LOCAL,
  OFFICE_SEO_NYC_OFFICE_ASSISTANT_COMPLIANCE_LOCAL,
  officeSeoMetroWideDemandPullquoteBold,
  officeSeoNycCleaningLogisticsLocal,
  officeSeoNycFurnitureFreightLocal,
  officeSeoNycInternetRiserLocal,
  officeSeoNycPantryDeliveryLocal,
  officeSeoNycDeepCleaningLocal,
  officeSeoNycCarpetCleaningLocal,
  officeSeoNycWindowCleaningLocal,
  officeSeoNycGlassCleaningLocal,
  officeSeoNycWasteRecyclingLocal,
  officeSeoNycPantryInventoryLocal,
  officeSeoNycCoffeeServiceLocal,
  officeSeoNycWaterServiceLocal,
  officeSeoNycTeamLunchLocal,
  officeSeoNycBreakfastCateringLocal,
  officeSeoNycIndividualMealsLocal,
  officeSeoNycAdHocCateringLocal,
  officeSeoNycHappyHourLocal,
  OFFICE_SEO_SF_CONFERENCE_ROOM_AV_LOCAL,
  OFFICE_SEO_SF_NETWORK_INSTALLATION_LOCAL,
  OFFICE_SEO_SF_NETWORK_MANAGEMENT_LOCAL,
  OFFICE_SEO_SF_CABLE_MANAGEMENT_LOCAL,
  OFFICE_SEO_SF_ROOM_BOOKING_LOCAL,
  OFFICE_SEO_SF_PRINTING_SETUP_LOCAL,
  officeSeoNycConferenceRoomAvLocal,
  officeSeoNycNetworkInstallationLocal,
  officeSeoNycNetworkManagementLocal,
  officeSeoNycCableManagementLocal,
  officeSeoNycRoomBookingLocal,
  officeSeoNycPrintingSetupLocal,
  OFFICE_SEO_SF_INTERIOR_DESIGN_LOCAL,
  OFFICE_SEO_SF_OFFICE_MURALS_LOCAL,
  OFFICE_SEO_SF_OFFICE_PAINTING_LOCAL,
  OFFICE_SEO_SF_GLASS_FROSTING_LOCAL,
  OFFICE_SEO_SF_OFFICE_SIGNAGE_LOCAL,
  OFFICE_SEO_SF_CARE_ROOM_LOCAL,
  OFFICE_SEO_SF_FURNITURE_ASSEMBLY_LOCAL,
  OFFICE_SEO_SF_LAYOUT_CHANGE_LOCAL,
  OFFICE_SEO_SF_OFFICE_PLANTS_LOCAL,
  officeSeoNycInteriorDesignLocal,
  officeSeoNycOfficeMuralsLocal,
  officeSeoNycOfficePaintingLocal,
  officeSeoNycGlassFrostingLocal,
  officeSeoNycOfficeSignageLocal,
  officeSeoNycCareRoomLocal,
  officeSeoNycFurnitureAssemblyLocal,
  officeSeoNycLayoutChangeLocal,
  officeSeoNycOfficePlantsLocal,
  OFFICE_SEO_SF_KEYLESS_ACCESS_LOCAL,
  OFFICE_SEO_SF_ALARM_SYSTEMS_LOCAL,
  OFFICE_SEO_SF_SECURITY_CAMERAS_LOCAL,
  OFFICE_SEO_SF_KEYPADS_LOCAL,
  OFFICE_SEO_SF_LOCKBOXES_LOCAL,
  OFFICE_SEO_SF_VISITOR_MANAGEMENT_LOCAL,
  OFFICE_SEO_SF_BUSINESS_INSURANCE_LOCAL,
  officeSeoNycKeylessAccessLocal,
  officeSeoNycAlarmSystemsLocal,
  officeSeoNycSecurityCamerasLocal,
  officeSeoNycKeypadsLocal,
  officeSeoNycLockboxesLocal,
  officeSeoNycVisitorManagementLocal,
  officeSeoNycBusinessInsuranceLocal,
  OFFICE_SEO_SF_ELECTRICAL_SERVICES_LOCAL,
  OFFICE_SEO_SF_HVAC_LOCAL,
  OFFICE_SEO_SF_PLUMBING_LOCAL,
  OFFICE_SEO_SF_PEST_CONTROL_LOCAL,
  OFFICE_SEO_SF_OFFICE_MOVING_LOCAL,
  OFFICE_SEO_SF_MOUNTING_INSTALLATION_LOCAL,
  officeSeoNycElectricalServicesLocal,
  officeSeoNycHvacLocal,
  officeSeoNycPlumbingLocal,
  officeSeoNycPestControlLocal,
  officeSeoNycOfficeMovingLocal,
  officeSeoNycMountingInstallationLocal,
  type OfficeSeoDemandPullquoteMetro,
  type OfficeSeoNycLocalPreset
} from 'ux/Public/OfficeSeo/data/officeSeoCityCopy';
import { officeSeoOfficesHaveVerb, officeSeoOfficesNoun } from 'ux/Public/OfficeSeo/data/officeSeoPluralize';
import type { NeighborhoodOfficeSeoData, OfficeSeoServiceKey } from 'ux/Public/OfficeSeo/data/types';

const ALL_OFFICE_SEO_SERVICE_KEYS: OfficeSeoServiceKey[] = [
  'cleaning',
  'pantryRestocking',
  'internet',
  'officeAssistant',
  'officeFurniture',
  'deepCleaning',
  'carpetCleaning',
  'windowCleaning',
  'glassConferenceRoom',
  'wasteRecycling',
  'pantryInventory',
  'coffeeService',
  'waterService',
  'teamLunch',
  'breakfastCatering',
  'individualMeals',
  'adHocCatering',
  'happyHour',
  'conferenceRoomAv',
  'networkInstallation',
  'networkManagement',
  'cableManagement',
  'roomBooking',
  'printingSetup',
  'interiorDesign',
  'officeMurals',
  'officePainting',
  'glassFrosting',
  'officeSignage',
  'careRoom',
  'furnitureAssembly',
  'layoutChange',
  'officePlants',
  'keylessAccess',
  'alarmSystems',
  'securityCameras',
  'keypads',
  'lockboxes',
  'visitorManagement',
  'businessInsurance',
  'electricalServices',
  'hvac',
  'plumbing',
  'pestControl',
  'officeMoving',
  'mountingInstallation'
];

export type OfficeSeoNeighborhoodAuthoringCounts = {
  managedCleaningOffices: number;
  managedPantryOffices: number;
  managedInternetOffices: number;
  managedFurnitureOffices: number;
  managedDeepCleaningOffices: number;
  managedCarpetCleaningOffices: number;
  managedWindowCleaningOffices: number;
  managedGlassCleaningOffices: number;
  managedWasteRecyclingOffices: number;
  managedPantryInventoryOffices: number;
  managedCoffeeServiceOffices: number;
  managedWaterServiceOffices: number;
  managedTeamLunchOffices: number;
  managedBreakfastCateringOffices: number;
  managedIndividualMealsOffices: number;
  managedAdHocCateringOffices: number;
  managedHappyHourOffices: number;
  managedConferenceRoomAvOffices: number;
  managedNetworkInstallationOffices: number;
  managedNetworkManagementOffices: number;
  managedCableManagementOffices: number;
  managedRoomBookingOffices: number;
  managedPrintingSetupOffices: number;
  managedInteriorDesignOffices: number;
  managedOfficeMuralsOffices: number;
  managedOfficePaintingOffices: number;
  managedGlassFrostingOffices: number;
  managedOfficeSignageOffices: number;
  managedCareRoomOffices: number;
  managedFurnitureAssemblyOffices: number;
  managedLayoutChangeOffices: number;
  managedOfficePlantsOffices: number;
  managedKeylessAccessOffices: number;
  managedAlarmSystemsOffices: number;
  managedSecurityCamerasOffices: number;
  managedKeypadOffices: number;
  managedLockboxOffices: number;
  managedVisitorManagementOffices: number;
  managedBusinessInsuranceOffices: number;
  managedElectricalServicesOffices: number;
  managedHvacOffices: number;
  managedPlumbingOffices: number;
  managedPestControlOffices: number;
  managedOfficeMovingOffices: number;
  managedMountingInstallationOffices: number;
  /**
   * Used for the standard "N out of M offices\u2026" assistant line when `officeAssistant.demandRest`
   * is omitted. Omit when assistant copy is fully custom (e.g. Flatiron).
   */
  managedOfficeAssistantOffices?: number;
};

export type OfficeSeoNeighborhoodAuthoringOfficeAssistant = {
  /** Defaults to "Office management". */
  demandLead?: string;
  /**
   * When set, used verbatim. Otherwise built from `counts.managedOfficeAssistantOffices` and
   * `totalCodiClientsInNeighborhood` (requires `managedOfficeAssistantOffices`).
   */
  demandRest?: string;
  /** Override city default compliance paragraph. */
  complianceLocal?: string;
};

export type OfficeSeoNeighborhoodAuthoring = {
  cityPathSegment: 'san-francisco' | 'new-york';
  neighborhoodSlug: string;
  neighborhoodDisplayName: string;
  metroDisplayName: string;
  totalCodiClientsInNeighborhood: number;
  whereFromStreetsToLandmark: string;
  whereTeamStreets: string;
  /** Default client vignette; use `clientDescriptorByService` for per-service overrides. */
  clientDescriptor: string;
  clientDescriptorByService?: Partial<Record<OfficeSeoServiceKey, string>>;
  clientEngagementByService?: Partial<Record<OfficeSeoServiceKey, string>>;
  counts: OfficeSeoNeighborhoodAuthoringCounts;
  quotes: Record<OfficeSeoServiceKey, string>;
  officeAssistant: OfficeSeoNeighborhoodAuthoringOfficeAssistant;
  /** Required when `cityPathSegment === 'new-york'` (selects shared Manhattan copy variants). */
  nycLocalPreset?: OfficeSeoNycLocalPreset;
  /**
   * Per service, use the long "Across {Metro}, \u2026 top 3 \u2026" demand line instead of neighborhood counts.
   * `'all'` expands to every service key.
   */
  metroWideDemandPullquote?: 'all' | OfficeSeoServiceKey[];
};

function demandPullquoteMetro(cityPathSegment: 'san-francisco' | 'new-york'): OfficeSeoDemandPullquoteMetro {
  return cityPathSegment === 'new-york' ? 'new-york' : 'san-francisco';
}

function resolveMetroWideServices(
  metroWideDemandPullquote: OfficeSeoNeighborhoodAuthoring['metroWideDemandPullquote']
): Set<OfficeSeoServiceKey> | null {
  if (metroWideDemandPullquote === undefined) return null;
  if (metroWideDemandPullquote === 'all') return new Set(ALL_OFFICE_SEO_SERVICE_KEYS);
  return new Set(metroWideDemandPullquote);
}

function clientDescriptorForService(
  authoring: OfficeSeoNeighborhoodAuthoringForBuild,
  serviceKey: OfficeSeoServiceKey
): string {
  return authoring.clientDescriptorByService?.[serviceKey] ?? authoring.clientDescriptor;
}

function clientEngagementForService(
  authoring: OfficeSeoNeighborhoodAuthoringForBuild,
  serviceKey: OfficeSeoServiceKey
): string {
  return authoring.clientEngagementByService?.[serviceKey] ?? OFFICE_SEO_DEFAULT_CLIENT_ENGAGEMENT[serviceKey];
}

/** Internal: after defaults applied */
type OfficeSeoNeighborhoodAuthoringForBuild = OfficeSeoNeighborhoodAuthoring & {
  nycLocalPreset: OfficeSeoNycLocalPreset;
};

function assertNycPreset(authoring: OfficeSeoNeighborhoodAuthoring): OfficeSeoNeighborhoodAuthoringForBuild {
  if (authoring.cityPathSegment === 'new-york' && authoring.nycLocalPreset === undefined) {
    throw new Error(
      `Office SEO neighborhood "${authoring.neighborhoodSlug}": nycLocalPreset is required for New York entries`
    );
  }

  const nycLocalPreset: OfficeSeoNycLocalPreset =
    authoring.cityPathSegment === 'new-york' ? authoring.nycLocalPreset! : 'manhattanStandard';

  return { ...authoring, nycLocalPreset };
}

function officeAssistantDemandRest(authoring: OfficeSeoNeighborhoodAuthoringForBuild): string {
  if (authoring.officeAssistant.demandRest !== undefined) return authoring.officeAssistant.demandRest;

  const n = authoring.counts.managedOfficeAssistantOffices;
  if (n === undefined) {
    throw new Error(
      `Office SEO neighborhood "${authoring.neighborhoodSlug}": officeAssistant.demandRest or counts.managedOfficeAssistantOffices is required`
    );
  }

  const total = authoring.totalCodiClientsInNeighborhood;
  const officeWord = officeSeoOfficesNoun(total);
  const have = officeSeoOfficesHaveVerb(total);
  return `${n} out of ${total} ${officeWord} in this neighborhood ${have} it on a recurring schedule`;
}

export function buildNeighborhoodOfficeSeo(authoring: OfficeSeoNeighborhoodAuthoring): NeighborhoodOfficeSeoData {
  const a = assertNycPreset(authoring);
  const metroWide = resolveMetroWideServices(a.metroWideDemandPullquote);
  const pullquoteMetro = demandPullquoteMetro(a.cityPathSegment);

  const cleaningDemand =
    metroWide?.has('cleaning') === true ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'cleaning') : undefined;

  const pantryDemand =
    metroWide?.has('pantryRestocking') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'pantryRestocking')
      : undefined;

  const internetDemand =
    metroWide?.has('internet') === true ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'internet') : undefined;

  const assistantDemand =
    metroWide?.has('officeAssistant') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officeAssistant')
      : undefined;

  const furnitureDemand =
    metroWide?.has('officeFurniture') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officeFurniture')
      : undefined;

  const deepCleaningDemand =
    metroWide?.has('deepCleaning') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'deepCleaning')
      : undefined;

  const carpetCleaningDemand =
    metroWide?.has('carpetCleaning') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'carpetCleaning')
      : undefined;

  const windowCleaningDemand =
    metroWide?.has('windowCleaning') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'windowCleaning')
      : undefined;

  const glassCleaningDemand =
    metroWide?.has('glassConferenceRoom') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'glassConferenceRoom')
      : undefined;

  const wasteRecyclingDemand =
    metroWide?.has('wasteRecycling') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'wasteRecycling')
      : undefined;

  const pantryInventoryDemand =
    metroWide?.has('pantryInventory') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'pantryInventory')
      : undefined;

  const coffeeServiceDemand =
    metroWide?.has('coffeeService') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'coffeeService')
      : undefined;

  const waterServiceDemand =
    metroWide?.has('waterService') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'waterService')
      : undefined;

  const teamLunchDemand =
    metroWide?.has('teamLunch') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'teamLunch')
      : undefined;

  const breakfastCateringDemand =
    metroWide?.has('breakfastCatering') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'breakfastCatering')
      : undefined;

  const individualMealsDemand =
    metroWide?.has('individualMeals') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'individualMeals')
      : undefined;

  const adHocCateringDemand =
    metroWide?.has('adHocCatering') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'adHocCatering')
      : undefined;

  const happyHourDemand =
    metroWide?.has('happyHour') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'happyHour')
      : undefined;

  const conferenceRoomAvDemand =
    metroWide?.has('conferenceRoomAv') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'conferenceRoomAv')
      : undefined;

  const networkInstallationDemand =
    metroWide?.has('networkInstallation') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'networkInstallation')
      : undefined;

  const networkManagementDemand =
    metroWide?.has('networkManagement') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'networkManagement')
      : undefined;

  const cableManagementDemand =
    metroWide?.has('cableManagement') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'cableManagement')
      : undefined;

  const roomBookingDemand =
    metroWide?.has('roomBooking') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'roomBooking')
      : undefined;

  const printingSetupDemand =
    metroWide?.has('printingSetup') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'printingSetup')
      : undefined;

  const interiorDesignDemand =
    metroWide?.has('interiorDesign') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'interiorDesign')
      : undefined;

  const officeMuralsDemand =
    metroWide?.has('officeMurals') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officeMurals')
      : undefined;

  const officePaintingDemand =
    metroWide?.has('officePainting') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officePainting')
      : undefined;

  const glassFrostingDemand =
    metroWide?.has('glassFrosting') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'glassFrosting')
      : undefined;

  const officeSignageDemand =
    metroWide?.has('officeSignage') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officeSignage')
      : undefined;

  const careRoomDemand =
    metroWide?.has('careRoom') === true ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'careRoom') : undefined;

  const furnitureAssemblyDemand =
    metroWide?.has('furnitureAssembly') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'furnitureAssembly')
      : undefined;

  const layoutChangeDemand =
    metroWide?.has('layoutChange') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'layoutChange')
      : undefined;

  const officePlantsDemand =
    metroWide?.has('officePlants') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officePlants')
      : undefined;

  const keylessAccessDemand =
    metroWide?.has('keylessAccess') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'keylessAccess')
      : undefined;

  const alarmSystemsDemand =
    metroWide?.has('alarmSystems') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'alarmSystems')
      : undefined;

  const securityCamerasDemand =
    metroWide?.has('securityCameras') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'securityCameras')
      : undefined;

  const keypadsDemand =
    metroWide?.has('keypads') === true ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'keypads') : undefined;

  const lockboxesDemand =
    metroWide?.has('lockboxes') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'lockboxes')
      : undefined;

  const visitorManagementDemand =
    metroWide?.has('visitorManagement') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'visitorManagement')
      : undefined;

  const businessInsuranceDemand =
    metroWide?.has('businessInsurance') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'businessInsurance')
      : undefined;

  const electricalServicesDemand =
    metroWide?.has('electricalServices') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'electricalServices')
      : undefined;

  const hvacDemand =
    metroWide?.has('hvac') === true ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'hvac') : undefined;

  const plumbingDemand =
    metroWide?.has('plumbing') === true ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'plumbing') : undefined;

  const pestControlDemand =
    metroWide?.has('pestControl') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'pestControl')
      : undefined;

  const officeMovingDemand =
    metroWide?.has('officeMoving') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'officeMoving')
      : undefined;

  const mountingInstallationDemand =
    metroWide?.has('mountingInstallation') === true
      ? officeSeoMetroWideDemandPullquoteBold(pullquoteMetro, 'mountingInstallation')
      : undefined;

  const logisticsLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_LOGISTICS_LOCAL
      : officeSeoNycCleaningLogisticsLocal(a.nycLocalPreset);

  const deliveryLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_PANTRY_DELIVERY_LOCAL
      : officeSeoNycPantryDeliveryLocal(a.nycLocalPreset);

  const riserLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_INTERNET_RISER_LOCAL
      : officeSeoNycInternetRiserLocal(a.nycLocalPreset);

  const freightLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_FURNITURE_FREIGHT_LOCAL
      : officeSeoNycFurnitureFreightLocal(a.nycLocalPreset);

  const assistantComplianceLocal =
    a.officeAssistant.complianceLocal ??
    (a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_OFFICE_ASSISTANT_COMPLIANCE_LOCAL
      : OFFICE_SEO_NYC_OFFICE_ASSISTANT_COMPLIANCE_LOCAL);

  const deepCleaningLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_DEEP_CLEANING_LOCAL
      : officeSeoNycDeepCleaningLocal(a.nycLocalPreset);

  const carpetCleaningLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_CARPET_CLEANING_LOCAL
      : officeSeoNycCarpetCleaningLocal(a.nycLocalPreset);

  const windowCleaningLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_WINDOW_CLEANING_LOCAL
      : officeSeoNycWindowCleaningLocal(a.nycLocalPreset);

  const glassCleaningLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_GLASS_CLEANING_LOCAL
      : officeSeoNycGlassCleaningLocal(a.nycLocalPreset);

  const wasteRecyclingLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_WASTE_RECYCLING_LOCAL
      : officeSeoNycWasteRecyclingLocal(a.nycLocalPreset);

  const pantryInventoryLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_PANTRY_INVENTORY_LOCAL
      : officeSeoNycPantryInventoryLocal(a.nycLocalPreset);

  const coffeeServiceLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_COFFEE_SERVICE_LOCAL
      : officeSeoNycCoffeeServiceLocal(a.nycLocalPreset);

  const waterServiceLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_WATER_SERVICE_LOCAL
      : officeSeoNycWaterServiceLocal(a.nycLocalPreset);

  const teamLunchLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_TEAM_LUNCH_LOCAL
      : officeSeoNycTeamLunchLocal(a.nycLocalPreset);

  const breakfastCateringLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_BREAKFAST_CATERING_LOCAL
      : officeSeoNycBreakfastCateringLocal(a.nycLocalPreset);

  const individualMealsLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_INDIVIDUAL_MEALS_LOCAL
      : officeSeoNycIndividualMealsLocal(a.nycLocalPreset);

  const adHocCateringLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_AD_HOC_CATERING_LOCAL
      : officeSeoNycAdHocCateringLocal(a.nycLocalPreset);

  const happyHourLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_HAPPY_HOUR_LOCAL
      : officeSeoNycHappyHourLocal(a.nycLocalPreset);

  const conferenceRoomAvLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_CONFERENCE_ROOM_AV_LOCAL
      : officeSeoNycConferenceRoomAvLocal(a.nycLocalPreset);

  const networkInstallationLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_NETWORK_INSTALLATION_LOCAL
      : officeSeoNycNetworkInstallationLocal(a.nycLocalPreset);

  const networkManagementLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_NETWORK_MANAGEMENT_LOCAL
      : officeSeoNycNetworkManagementLocal(a.nycLocalPreset);

  const cableManagementLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_CABLE_MANAGEMENT_LOCAL
      : officeSeoNycCableManagementLocal(a.nycLocalPreset);

  const roomBookingLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_ROOM_BOOKING_LOCAL
      : officeSeoNycRoomBookingLocal(a.nycLocalPreset);

  const printingSetupLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_PRINTING_SETUP_LOCAL
      : officeSeoNycPrintingSetupLocal(a.nycLocalPreset);

  const interiorDesignLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_INTERIOR_DESIGN_LOCAL
      : officeSeoNycInteriorDesignLocal(a.nycLocalPreset);

  const officeMuralsLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_OFFICE_MURALS_LOCAL
      : officeSeoNycOfficeMuralsLocal(a.nycLocalPreset);

  const officePaintingLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_OFFICE_PAINTING_LOCAL
      : officeSeoNycOfficePaintingLocal(a.nycLocalPreset);

  const glassFrostingLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_GLASS_FROSTING_LOCAL
      : officeSeoNycGlassFrostingLocal(a.nycLocalPreset);

  const officeSignageLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_OFFICE_SIGNAGE_LOCAL
      : officeSeoNycOfficeSignageLocal(a.nycLocalPreset);

  const careRoomLocal =
    a.cityPathSegment === 'san-francisco' ? OFFICE_SEO_SF_CARE_ROOM_LOCAL : officeSeoNycCareRoomLocal(a.nycLocalPreset);

  const furnitureAssemblyLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_FURNITURE_ASSEMBLY_LOCAL
      : officeSeoNycFurnitureAssemblyLocal(a.nycLocalPreset);

  const layoutChangeLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_LAYOUT_CHANGE_LOCAL
      : officeSeoNycLayoutChangeLocal(a.nycLocalPreset);

  const officePlantsLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_OFFICE_PLANTS_LOCAL
      : officeSeoNycOfficePlantsLocal(a.nycLocalPreset);

  const keylessAccessLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_KEYLESS_ACCESS_LOCAL
      : officeSeoNycKeylessAccessLocal(a.nycLocalPreset);

  const alarmSystemsLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_ALARM_SYSTEMS_LOCAL
      : officeSeoNycAlarmSystemsLocal(a.nycLocalPreset);

  const securityCamerasLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_SECURITY_CAMERAS_LOCAL
      : officeSeoNycSecurityCamerasLocal(a.nycLocalPreset);

  const keypadsLocal =
    a.cityPathSegment === 'san-francisco' ? OFFICE_SEO_SF_KEYPADS_LOCAL : officeSeoNycKeypadsLocal(a.nycLocalPreset);

  const lockboxesLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_LOCKBOXES_LOCAL
      : officeSeoNycLockboxesLocal(a.nycLocalPreset);

  const visitorManagementLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_VISITOR_MANAGEMENT_LOCAL
      : officeSeoNycVisitorManagementLocal(a.nycLocalPreset);

  const businessInsuranceLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_BUSINESS_INSURANCE_LOCAL
      : officeSeoNycBusinessInsuranceLocal(a.nycLocalPreset);

  const electricalServicesLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_ELECTRICAL_SERVICES_LOCAL
      : officeSeoNycElectricalServicesLocal(a.nycLocalPreset);

  const hvacLocal =
    a.cityPathSegment === 'san-francisco' ? OFFICE_SEO_SF_HVAC_LOCAL : officeSeoNycHvacLocal(a.nycLocalPreset);

  const plumbingLocal =
    a.cityPathSegment === 'san-francisco' ? OFFICE_SEO_SF_PLUMBING_LOCAL : officeSeoNycPlumbingLocal(a.nycLocalPreset);

  const pestControlLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_PEST_CONTROL_LOCAL
      : officeSeoNycPestControlLocal(a.nycLocalPreset);

  const officeMovingLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_OFFICE_MOVING_LOCAL
      : officeSeoNycOfficeMovingLocal(a.nycLocalPreset);

  const mountingInstallationLocal =
    a.cityPathSegment === 'san-francisco'
      ? OFFICE_SEO_SF_MOUNTING_INSTALLATION_LOCAL
      : officeSeoNycMountingInstallationLocal(a.nycLocalPreset);

  return {
    cityPathSegment: a.cityPathSegment,
    neighborhoodSlug: a.neighborhoodSlug,
    neighborhoodDisplayName: a.neighborhoodDisplayName,
    metroDisplayName: a.metroDisplayName,
    totalCodiClientsInNeighborhood: a.totalCodiClientsInNeighborhood,
    services: {
      cleaning: {
        clientDescriptor: clientDescriptorForService(a, 'cleaning'),
        clientEngagement: clientEngagementForService(a, 'cleaning'),
        clientQuote: a.quotes.cleaning,
        logisticsLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedCleaningOffices: a.counts.managedCleaningOffices,
        demandPullquoteBoldOverride: cleaningDemand
      },
      pantryRestocking: {
        clientDescriptor: clientDescriptorForService(a, 'pantryRestocking'),
        clientEngagement: clientEngagementForService(a, 'pantryRestocking'),
        clientQuote: a.quotes.pantryRestocking,
        deliveryLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedPantryOffices: a.counts.managedPantryOffices,
        demandPullquoteBoldOverride: pantryDemand
      },
      internet: {
        clientDescriptor: clientDescriptorForService(a, 'internet'),
        clientEngagement: clientEngagementForService(a, 'internet'),
        clientQuote: a.quotes.internet,
        riserLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedInternetOffices: a.counts.managedInternetOffices,
        demandPullquoteBoldOverride: internetDemand
      },
      officeAssistant: {
        clientDescriptor: clientDescriptorForService(a, 'officeAssistant'),
        clientEngagement: clientEngagementForService(a, 'officeAssistant'),
        clientQuote: a.quotes.officeAssistant,
        demandLead: a.officeAssistant.demandLead ?? 'Office management',
        demandRest: officeAssistantDemandRest(a),
        complianceLocal: assistantComplianceLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        demandPullquoteBoldOverride: assistantDemand
      },
      officeFurniture: {
        clientDescriptor: clientDescriptorForService(a, 'officeFurniture'),
        clientEngagement: clientEngagementForService(a, 'officeFurniture'),
        clientQuote: a.quotes.officeFurniture,
        freightLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedFurnitureOffices: a.counts.managedFurnitureOffices,
        demandPullquoteBoldOverride: furnitureDemand
      },
      deepCleaning: {
        clientDescriptor: clientDescriptorForService(a, 'deepCleaning'),
        clientEngagement: clientEngagementForService(a, 'deepCleaning'),
        clientQuote: a.quotes.deepCleaning,
        logisticsLocal: deepCleaningLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedDeepCleaningOffices: a.counts.managedDeepCleaningOffices,
        demandPullquoteBoldOverride: deepCleaningDemand
      },
      carpetCleaning: {
        clientDescriptor: clientDescriptorForService(a, 'carpetCleaning'),
        clientEngagement: clientEngagementForService(a, 'carpetCleaning'),
        clientQuote: a.quotes.carpetCleaning,
        logisticsLocal: carpetCleaningLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedCarpetCleaningOffices: a.counts.managedCarpetCleaningOffices,
        demandPullquoteBoldOverride: carpetCleaningDemand
      },
      windowCleaning: {
        clientDescriptor: clientDescriptorForService(a, 'windowCleaning'),
        clientEngagement: clientEngagementForService(a, 'windowCleaning'),
        clientQuote: a.quotes.windowCleaning,
        logisticsLocal: windowCleaningLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedWindowCleaningOffices: a.counts.managedWindowCleaningOffices,
        demandPullquoteBoldOverride: windowCleaningDemand
      },
      glassConferenceRoom: {
        clientDescriptor: clientDescriptorForService(a, 'glassConferenceRoom'),
        clientEngagement: clientEngagementForService(a, 'glassConferenceRoom'),
        clientQuote: a.quotes.glassConferenceRoom,
        logisticsLocal: glassCleaningLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedGlassCleaningOffices: a.counts.managedGlassCleaningOffices,
        demandPullquoteBoldOverride: glassCleaningDemand
      },
      wasteRecycling: {
        clientDescriptor: clientDescriptorForService(a, 'wasteRecycling'),
        clientEngagement: clientEngagementForService(a, 'wasteRecycling'),
        clientQuote: a.quotes.wasteRecycling,
        logisticsLocal: wasteRecyclingLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedWasteRecyclingOffices: a.counts.managedWasteRecyclingOffices,
        demandPullquoteBoldOverride: wasteRecyclingDemand
      },
      pantryInventory: {
        clientDescriptor: clientDescriptorForService(a, 'pantryInventory'),
        clientEngagement: clientEngagementForService(a, 'pantryInventory'),
        clientQuote: a.quotes.pantryInventory,
        logisticsLocal: pantryInventoryLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedPantryInventoryOffices: a.counts.managedPantryInventoryOffices,
        demandPullquoteBoldOverride: pantryInventoryDemand
      },
      coffeeService: {
        clientDescriptor: clientDescriptorForService(a, 'coffeeService'),
        clientEngagement: clientEngagementForService(a, 'coffeeService'),
        clientQuote: a.quotes.coffeeService,
        logisticsLocal: coffeeServiceLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedCoffeeServiceOffices: a.counts.managedCoffeeServiceOffices,
        demandPullquoteBoldOverride: coffeeServiceDemand
      },
      waterService: {
        clientDescriptor: clientDescriptorForService(a, 'waterService'),
        clientEngagement: clientEngagementForService(a, 'waterService'),
        clientQuote: a.quotes.waterService,
        logisticsLocal: waterServiceLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedWaterServiceOffices: a.counts.managedWaterServiceOffices,
        demandPullquoteBoldOverride: waterServiceDemand
      },
      teamLunch: {
        clientDescriptor: clientDescriptorForService(a, 'teamLunch'),
        clientEngagement: clientEngagementForService(a, 'teamLunch'),
        clientQuote: a.quotes.teamLunch,
        logisticsLocal: teamLunchLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedTeamLunchOffices: a.counts.managedTeamLunchOffices,
        demandPullquoteBoldOverride: teamLunchDemand
      },
      breakfastCatering: {
        clientDescriptor: clientDescriptorForService(a, 'breakfastCatering'),
        clientEngagement: clientEngagementForService(a, 'breakfastCatering'),
        clientQuote: a.quotes.breakfastCatering,
        logisticsLocal: breakfastCateringLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedBreakfastCateringOffices: a.counts.managedBreakfastCateringOffices,
        demandPullquoteBoldOverride: breakfastCateringDemand
      },
      individualMeals: {
        clientDescriptor: clientDescriptorForService(a, 'individualMeals'),
        clientEngagement: clientEngagementForService(a, 'individualMeals'),
        clientQuote: a.quotes.individualMeals,
        logisticsLocal: individualMealsLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedIndividualMealsOffices: a.counts.managedIndividualMealsOffices,
        demandPullquoteBoldOverride: individualMealsDemand
      },
      adHocCatering: {
        clientDescriptor: clientDescriptorForService(a, 'adHocCatering'),
        clientEngagement: clientEngagementForService(a, 'adHocCatering'),
        clientQuote: a.quotes.adHocCatering,
        logisticsLocal: adHocCateringLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedAdHocCateringOffices: a.counts.managedAdHocCateringOffices,
        demandPullquoteBoldOverride: adHocCateringDemand
      },
      happyHour: {
        clientDescriptor: clientDescriptorForService(a, 'happyHour'),
        clientEngagement: clientEngagementForService(a, 'happyHour'),
        clientQuote: a.quotes.happyHour,
        logisticsLocal: happyHourLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedHappyHourOffices: a.counts.managedHappyHourOffices,
        demandPullquoteBoldOverride: happyHourDemand
      },
      conferenceRoomAv: {
        clientDescriptor: clientDescriptorForService(a, 'conferenceRoomAv'),
        clientEngagement: clientEngagementForService(a, 'conferenceRoomAv'),
        clientQuote: a.quotes.conferenceRoomAv,
        logisticsLocal: conferenceRoomAvLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedConferenceRoomAvOffices: a.counts.managedConferenceRoomAvOffices,
        demandPullquoteBoldOverride: conferenceRoomAvDemand
      },
      networkInstallation: {
        clientDescriptor: clientDescriptorForService(a, 'networkInstallation'),
        clientEngagement: clientEngagementForService(a, 'networkInstallation'),
        clientQuote: a.quotes.networkInstallation,
        logisticsLocal: networkInstallationLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedNetworkInstallationOffices: a.counts.managedNetworkInstallationOffices,
        demandPullquoteBoldOverride: networkInstallationDemand
      },
      networkManagement: {
        clientDescriptor: clientDescriptorForService(a, 'networkManagement'),
        clientEngagement: clientEngagementForService(a, 'networkManagement'),
        clientQuote: a.quotes.networkManagement,
        logisticsLocal: networkManagementLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedNetworkManagementOffices: a.counts.managedNetworkManagementOffices,
        demandPullquoteBoldOverride: networkManagementDemand
      },
      cableManagement: {
        clientDescriptor: clientDescriptorForService(a, 'cableManagement'),
        clientEngagement: clientEngagementForService(a, 'cableManagement'),
        clientQuote: a.quotes.cableManagement,
        logisticsLocal: cableManagementLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedCableManagementOffices: a.counts.managedCableManagementOffices,
        demandPullquoteBoldOverride: cableManagementDemand
      },
      roomBooking: {
        clientDescriptor: clientDescriptorForService(a, 'roomBooking'),
        clientEngagement: clientEngagementForService(a, 'roomBooking'),
        clientQuote: a.quotes.roomBooking,
        logisticsLocal: roomBookingLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedRoomBookingOffices: a.counts.managedRoomBookingOffices,
        demandPullquoteBoldOverride: roomBookingDemand
      },
      printingSetup: {
        clientDescriptor: clientDescriptorForService(a, 'printingSetup'),
        clientEngagement: clientEngagementForService(a, 'printingSetup'),
        clientQuote: a.quotes.printingSetup,
        logisticsLocal: printingSetupLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedPrintingSetupOffices: a.counts.managedPrintingSetupOffices,
        demandPullquoteBoldOverride: printingSetupDemand
      },
      interiorDesign: {
        clientDescriptor: clientDescriptorForService(a, 'interiorDesign'),
        clientEngagement: clientEngagementForService(a, 'interiorDesign'),
        clientQuote: a.quotes.interiorDesign,
        logisticsLocal: interiorDesignLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedInteriorDesignOffices: a.counts.managedInteriorDesignOffices,
        demandPullquoteBoldOverride: interiorDesignDemand
      },
      officeMurals: {
        clientDescriptor: clientDescriptorForService(a, 'officeMurals'),
        clientEngagement: clientEngagementForService(a, 'officeMurals'),
        clientQuote: a.quotes.officeMurals,
        logisticsLocal: officeMuralsLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedOfficeMuralsOffices: a.counts.managedOfficeMuralsOffices,
        demandPullquoteBoldOverride: officeMuralsDemand
      },
      officePainting: {
        clientDescriptor: clientDescriptorForService(a, 'officePainting'),
        clientEngagement: clientEngagementForService(a, 'officePainting'),
        clientQuote: a.quotes.officePainting,
        logisticsLocal: officePaintingLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedOfficePaintingOffices: a.counts.managedOfficePaintingOffices,
        demandPullquoteBoldOverride: officePaintingDemand
      },
      glassFrosting: {
        clientDescriptor: clientDescriptorForService(a, 'glassFrosting'),
        clientEngagement: clientEngagementForService(a, 'glassFrosting'),
        clientQuote: a.quotes.glassFrosting,
        logisticsLocal: glassFrostingLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedGlassFrostingOffices: a.counts.managedGlassFrostingOffices,
        demandPullquoteBoldOverride: glassFrostingDemand
      },
      officeSignage: {
        clientDescriptor: clientDescriptorForService(a, 'officeSignage'),
        clientEngagement: clientEngagementForService(a, 'officeSignage'),
        clientQuote: a.quotes.officeSignage,
        logisticsLocal: officeSignageLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedOfficeSignageOffices: a.counts.managedOfficeSignageOffices,
        demandPullquoteBoldOverride: officeSignageDemand
      },
      careRoom: {
        clientDescriptor: clientDescriptorForService(a, 'careRoom'),
        clientEngagement: clientEngagementForService(a, 'careRoom'),
        clientQuote: a.quotes.careRoom,
        logisticsLocal: careRoomLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedCareRoomOffices: a.counts.managedCareRoomOffices,
        demandPullquoteBoldOverride: careRoomDemand
      },
      furnitureAssembly: {
        clientDescriptor: clientDescriptorForService(a, 'furnitureAssembly'),
        clientEngagement: clientEngagementForService(a, 'furnitureAssembly'),
        clientQuote: a.quotes.furnitureAssembly,
        logisticsLocal: furnitureAssemblyLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedFurnitureAssemblyOffices: a.counts.managedFurnitureAssemblyOffices,
        demandPullquoteBoldOverride: furnitureAssemblyDemand
      },
      layoutChange: {
        clientDescriptor: clientDescriptorForService(a, 'layoutChange'),
        clientEngagement: clientEngagementForService(a, 'layoutChange'),
        clientQuote: a.quotes.layoutChange,
        logisticsLocal: layoutChangeLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedLayoutChangeOffices: a.counts.managedLayoutChangeOffices,
        demandPullquoteBoldOverride: layoutChangeDemand
      },
      officePlants: {
        clientDescriptor: clientDescriptorForService(a, 'officePlants'),
        clientEngagement: clientEngagementForService(a, 'officePlants'),
        clientQuote: a.quotes.officePlants,
        logisticsLocal: officePlantsLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedOfficePlantsOffices: a.counts.managedOfficePlantsOffices,
        demandPullquoteBoldOverride: officePlantsDemand
      },
      keylessAccess: {
        clientDescriptor: clientDescriptorForService(a, 'keylessAccess'),
        clientEngagement: clientEngagementForService(a, 'keylessAccess'),
        clientQuote: a.quotes.keylessAccess,
        logisticsLocal: keylessAccessLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedKeylessAccessOffices: a.counts.managedKeylessAccessOffices,
        demandPullquoteBoldOverride: keylessAccessDemand
      },
      alarmSystems: {
        clientDescriptor: clientDescriptorForService(a, 'alarmSystems'),
        clientEngagement: clientEngagementForService(a, 'alarmSystems'),
        clientQuote: a.quotes.alarmSystems,
        logisticsLocal: alarmSystemsLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedAlarmSystemsOffices: a.counts.managedAlarmSystemsOffices,
        demandPullquoteBoldOverride: alarmSystemsDemand
      },
      securityCameras: {
        clientDescriptor: clientDescriptorForService(a, 'securityCameras'),
        clientEngagement: clientEngagementForService(a, 'securityCameras'),
        clientQuote: a.quotes.securityCameras,
        logisticsLocal: securityCamerasLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedSecurityCamerasOffices: a.counts.managedSecurityCamerasOffices,
        demandPullquoteBoldOverride: securityCamerasDemand
      },
      keypads: {
        clientDescriptor: clientDescriptorForService(a, 'keypads'),
        clientEngagement: clientEngagementForService(a, 'keypads'),
        clientQuote: a.quotes.keypads,
        logisticsLocal: keypadsLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedKeypadOffices: a.counts.managedKeypadOffices,
        demandPullquoteBoldOverride: keypadsDemand
      },
      lockboxes: {
        clientDescriptor: clientDescriptorForService(a, 'lockboxes'),
        clientEngagement: clientEngagementForService(a, 'lockboxes'),
        clientQuote: a.quotes.lockboxes,
        logisticsLocal: lockboxesLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedLockboxOffices: a.counts.managedLockboxOffices,
        demandPullquoteBoldOverride: lockboxesDemand
      },
      visitorManagement: {
        clientDescriptor: clientDescriptorForService(a, 'visitorManagement'),
        clientEngagement: clientEngagementForService(a, 'visitorManagement'),
        clientQuote: a.quotes.visitorManagement,
        logisticsLocal: visitorManagementLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedVisitorManagementOffices: a.counts.managedVisitorManagementOffices,
        demandPullquoteBoldOverride: visitorManagementDemand
      },
      businessInsurance: {
        clientDescriptor: clientDescriptorForService(a, 'businessInsurance'),
        clientEngagement: clientEngagementForService(a, 'businessInsurance'),
        clientQuote: a.quotes.businessInsurance,
        logisticsLocal: businessInsuranceLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedBusinessInsuranceOffices: a.counts.managedBusinessInsuranceOffices,
        demandPullquoteBoldOverride: businessInsuranceDemand
      },
      electricalServices: {
        clientDescriptor: clientDescriptorForService(a, 'electricalServices'),
        clientEngagement: clientEngagementForService(a, 'electricalServices'),
        clientQuote: a.quotes.electricalServices,
        logisticsLocal: electricalServicesLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedElectricalServicesOffices: a.counts.managedElectricalServicesOffices,
        demandPullquoteBoldOverride: electricalServicesDemand
      },
      hvac: {
        clientDescriptor: clientDescriptorForService(a, 'hvac'),
        clientEngagement: clientEngagementForService(a, 'hvac'),
        clientQuote: a.quotes.hvac,
        logisticsLocal: hvacLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedHvacOffices: a.counts.managedHvacOffices,
        demandPullquoteBoldOverride: hvacDemand
      },
      plumbing: {
        clientDescriptor: clientDescriptorForService(a, 'plumbing'),
        clientEngagement: clientEngagementForService(a, 'plumbing'),
        clientQuote: a.quotes.plumbing,
        logisticsLocal: plumbingLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedPlumbingOffices: a.counts.managedPlumbingOffices,
        demandPullquoteBoldOverride: plumbingDemand
      },
      pestControl: {
        clientDescriptor: clientDescriptorForService(a, 'pestControl'),
        clientEngagement: clientEngagementForService(a, 'pestControl'),
        clientQuote: a.quotes.pestControl,
        logisticsLocal: pestControlLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedPestControlOffices: a.counts.managedPestControlOffices,
        demandPullquoteBoldOverride: pestControlDemand
      },
      officeMoving: {
        clientDescriptor: clientDescriptorForService(a, 'officeMoving'),
        clientEngagement: clientEngagementForService(a, 'officeMoving'),
        clientQuote: a.quotes.officeMoving,
        logisticsLocal: officeMovingLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedOfficeMovingOffices: a.counts.managedOfficeMovingOffices,
        demandPullquoteBoldOverride: officeMovingDemand
      },
      mountingInstallation: {
        clientDescriptor: clientDescriptorForService(a, 'mountingInstallation'),
        clientEngagement: clientEngagementForService(a, 'mountingInstallation'),
        clientQuote: a.quotes.mountingInstallation,
        logisticsLocal: mountingInstallationLocal,
        whereFromStreetsToLandmark: a.whereFromStreetsToLandmark,
        whereTeamStreets: a.whereTeamStreets,
        managedMountingInstallationOffices: a.counts.managedMountingInstallationOffices,
        demandPullquoteBoldOverride: mountingInstallationDemand
      }
    }
  };
}
